<template>
  <bg-yun>
    <div style="display: none">
      <slot></slot>
    </div>
    <div style="position: relative;" class="bg-white bgyunc">
      <img src="./gou-01.svg" width="20" v-show="order.check>0" class="order_identifying" alt="">
      <div class="flex-layout padding-16-10">
        <div class="flex-3 text-left color-black text-nowrap font-0-9-5">
          {{order.name}}
          <img height="18" :src="icon" v-for="icon in order.iconPath">
        </div>
        <div class="flex-1-3 text-right color-blue text-nowrap">
          <img v-if="order.memberprice &&order.price>order.memberprice" src="./vipIco.svg" width="18" alt="" class="vip-img" >
          <span v-if="order.memberprice &&order.price>order.memberprice">
            <!--<span class="font-0-7">￥</span>-->
            <span class="font-1-1 ">{{order.memberprice}}<span class="font-0-6">元</span></span>
          </span>
        </div>
        <div class="flex-1 text-right color-yellow text-nowrap">
          <span v-if="order.price">
            <!--<span class="font-0-7">￥</span>-->
            <span class="font-1-1 ">{{order.price}}<span class="font-0-6">元</span></span>
          </span>
        </div>
      </div>
      <div style="position: absolute;top:0;left:39%;pointer-events: none;" v-if="order.isSaleout"><img src="./soldout.svg" width="65"></div>
    </div>
  </bg-yun>
</template>
<script>
  import bgyun from "../bg-yun/bgyun";
  export default {
    data () {
      return{
      }
    },
    components:{
      'bg-yun':bgyun
    },
    props: {
      order: {}, //定义传值的类型<br>
      type:{},
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .font-0-6{font-size: 0.6em;}
  .bg-white{background:#ffffff}
  .flex-layout{ display: flex;  align-items: center;}
  .padding-16-10{padding: 16px 10px;}
  .flex-3{flex:3;overflow:hidden;width: 0}
  .text-left{text-align: left;}
  .color-black{color:#000000}
  .text-nowrap{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .font-0-9-5{font-size: 0.95em;}
  .order_identifying{position: absolute;top: 0;right: 0;color: #fff;border-width: 10px;}
  .flex-1-3{flex:1.3;overflow:hidden;width: 0}
  .font-0-7{font-size: 0.7em;}
  .text-right{text-align: right;}
  .color-blue{color:#00ABF8}
  .font-1-1{font-size: 1.1em;}
  .vip-img{vertical-align: middle;padding-bottom: 4px;pointer-events: none;}
  .color-yellow{color:#FF6D00}
  .flex-1{flex:1;overflow:hidden;width: 0}
  .bgyunc{border: 1px solid #eeeeee;border-radius: 5px;}
</style>



// WEBPACK FOOTER //
// src/components/noPicMode/noPicMode.vue